import './bootstrap/css/bootstrap.min.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import configureStore from './redux/store/configureStore';

import './index.css'; // important! have this css loaded before the components & their css is imported.

import App from './containers/App';

console.log('...started...');
ReactDOM.render(
  <Provider store={configureStore({})}>
    <App />
  </Provider>,
  document.getElementById('root')
);
// NOTE: registerServiceWorker() was removed
